import { APIUrlConstants, AppConstants } from '../../../common/APIConstants';
import RestEndPoint from '../../../common/RestEndPoint';

export default class GainLossSubSystemVarianceAPI {

  static getSubSystemVarianceScreenData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetSubSystemVarianceScreenData,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
  static saveSubSystemVarianceScreenData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.SaveSubSystemVarianceScreenData,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
  static getSubSystemVarianceAuditHistory(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetSubSystemVarianceAuditHistory,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
}
